import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'

/**
 * Live SKU catalog (Stars + RUB prices, titles, descriptions, validity
 * windows for active promos). Reads from /api/payments/catalog so price
 * changes in the admin take effect without a redeploy.
 *
 * Cached for 5 minutes — prices change rarely, paying users wait < 5min
 * after an admin change to see new numbers.
 */
export function useCatalog() {
  return useQuery({
    queryKey: ['catalog'],
    queryFn: () => api.getCatalog(),
    staleTime: 5 * 60_000,
    refetchInterval: 5 * 60_000,
  })
}

export function useSkuPrice(sku: string): { priceStars: number; priceRub: number } | null {
  const { data } = useCatalog()
  const row = data?.find((r) => r.sku === sku)
  return row ? { priceStars: row.priceStars, priceRub: row.priceRub } : null
}
